import { useState } from 'react';
import { Form, Divider, Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import styled from 'styled-components';
import useLocalStorage from '../../../libs/useLocalStorage';
import Center from '../../../components/Auth/Center';
import HeaderLogo from '../../../components/Auth/HeaderLogo';
import CenterMessage from '../../../components/CenterMessage';
import ButtonStretch from '../../../components/ButtonStretch';
import { api_url } from '../../../config';

const Container = styled.div`
`;

const CustomCenter = styled(Center)`
	margin-top: 5px;
`;

const GridContainer = styled.div`
	position: relative;
	padding: 15px;
	width: 900px;
`;

const LeftContainer = styled.div`
	margin-top: 150px;
`;

const LoginContainer = styled.div`
	text-align: center;
`;

function Signup() {
	const [ , setJwtToken ]              = useLocalStorage(`jwt_token`);
	const [ , setUser ]                  = useLocalStorage(`user`);
	const [ loading, setLoading ]        = useState(false);
	const [ errors, setErrors ]          = useState([]);
	const [ message ]                    = useState(false);
	const [ signup_info, setSignupInfo ] = useState({
		first_name   : ``,
		last_name    : ``,
		organization : ``,
		email        : ``,
		password     : ``,
		password2    : ``,
		promo_code   : ``,
	});

	const required_fields = {
		first_name   : `First Name`,
		last_name    : `Last Name`,
		organization : `Company Name`,
		email        : `Email`,
		password     : `Password`,
		password2    : `Confirm Password`,
	};

	function handleChange(e) {
		setSignupInfo({
			...signup_info,
			...{ [e.target.name] : e.target.value },
		});
	}

	function handleSubmit() {
		setErrors([]);

		const errors = [];

		// Verify fields are filled in
		for(const [ field, display ] of Object.entries(required_fields)) {
			if(signup_info[field]) {
				continue;
			}

			errors.push(`${display} must be filled in`);
		}

		if(signup_info.password !== signup_info.password2) {
			errors.push(`Passwords do not match`);
		}

		if(signup_info.password.length < 7) {
			errors.push(`Password must be at least 7 characters long`);
		}

		if(errors.length) {
			setErrors(errors);
			return;
		}

		setLoading(true);
		fetch(`${api_url}/signup`, {
			method : `POST`,
			body   : JSON.stringify(signup_info),
			headers : {
				'Content-Type' : `application/json`
			}
		}).then(response => response.json()).then(data => {
			if(data.error || !data.jwt) {
				setErrors([data.error]);
				setLoading(false);

				return;
			}

			// Redirect to the home page, which will go to the payment page
			const decoded = jwt_decode(data.jwt);

			setJwtToken(data.jwt);
			setUser(decoded.sub.user);

			const location  = decoded.sub.user.payment_status === `free` ? `/` : `/payment`;
			window.location = location;
			setLoading(false);
		});
	}

	return (
		<Container>
			<Center>
				<HeaderLogo />
			</Center>

			<CustomCenter>
				<GridContainer>
					<Grid columns={2} relaxed="very" celled="internally">
						<Grid.Column>
							<LeftContainer>
								<h1>Sign up for a free 7 day trial</h1>

								<p>To learn more about pricing, visit <a href="/">testreporter.io/pricing</a></p>
								<p>To learn more about Test Reporter IO, visit <a href="/">testreporter.io</a></p>
							</LeftContainer>
						</Grid.Column>

						<Grid.Column>
							<Form>
								<Form.Field>
									<label>First Name</label>
									<input placeholder="First Name" name="first_name" value={signup_info.first_name} onChange={handleChange}></input>
								</Form.Field>

								<Form.Field>
									<label>Last Name</label>
									<input placeholder="Last Name" name="last_name" value={signup_info.last_name} onChange={handleChange}></input>
								</Form.Field>

								<Form.Field>
									<label>Company Name</label>
									<input placeholder="Company Name" name="organization" value={signup_info.organization} onChange={handleChange}></input>
								</Form.Field>

								<Form.Field>
									<label>Promo Code</label>
									<input placeholder="Promo Code" name="promo_code" value={signup_info.promo_code} onChange={handleChange}></input>
								</Form.Field>

								<Form.Field>
									<label>Email</label>
									<input placeholder="Email" name="email" value={signup_info.email} onChange={handleChange}></input>
								</Form.Field>

								<Form.Field>
									<label>Password</label>
									<input type="password" placeholder="Password" name="password" value={signup_info.password} onChange={handleChange}></input>
								</Form.Field>

								<Form.Field>
									<label>Confirm Password</label>
									<input type="password" placeholder="Confirm password" name="password2" value={signup_info.password2} onChange={handleChange}></input>
								</Form.Field>

								<ButtonStretch loading={loading} positive type="submit" onClick={handleSubmit}>Continue (step 1 of 2)</ButtonStretch>
							</Form>

							{message &&
								<CenterMessage positive>
									<p>An email confirmation has been sent to you. Please click the link in the email to confirm your account.</p>
								</CenterMessage>
							}

							{errors.length > 0 &&
								<CenterMessage negative>
									{errors.map((error, i) => <p key={i}>{error}</p>)}
								</CenterMessage>
							}
							<Divider />

							<LoginContainer>
								<Link to="/login">Log in to an existing account</Link>
							</LoginContainer>

						</Grid.Column>

					</Grid>
				</GridContainer>
			</CustomCenter>
		</Container>
	);
}

export default Signup;
